import React from 'react'
import './contact-card.css'
import { RiWhatsappFill } from "react-icons/ri";
import {
    HiChevronRight,
    HiLocationMarker,
    HiPhone,
    HiMail
} from "react-icons/hi";

const icons = {
    whatsapp: RiWhatsappFill,
    location: HiLocationMarker,
    phone: HiPhone,
    mail: HiMail
}

const ContactCard = ({ Action, ContactName, Description, Contact, Icon }) => {

    const SelectedIcon = icons[Icon];

    return (

        <button className='contact-card' onClick={Action}>

            <div className="icon">
                <SelectedIcon />
            </div>

            <div className="content">
                <span className='name app-little-title'>{ContactName}</span>
                <span className='description app-text'>{Description}</span>
                <span className='contact app-text'>{Contact}</span>
            </div>

            <HiChevronRight className='arrow' />
        </button>

    )
}

export default ContactCard